import React, { Component } from 'react';

import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import { getNewChartData, getDatasourceAndDates } from '../../../api';
import { isFullscreen } from '../utils/Utils';
import { largeSize, xlsxCustomExport } from '../utils/chartConfig';

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);

const IMG_URL = process.env.IMG_FULL_URL;

class TrendDiagram extends Component {

    constructor(props){
        super(props);
        const stateThis = this;

        let title = "Title";
        let width = window.innerWidth;
        if(this.props.title){
            title = this.props.title;
        }else{
            if(this.props.chartType != undefined){
                title = width < 768 ? this.props.literals['L'+this.props.tabIndicator] : this.props.literals['L'+this.props.chartType[0].title];
            }
        }

        this.state = {
            selectedTypeChart: this.props.selectedIndicator != undefined ? this.props.selectedIndicator :  this.props.chartType[0].type,
            selectedChart: this.props.chartType != undefined ? this.props.chartType[0]: undefined,
            selectedDataset1: undefined,
            selectedDataset2: undefined,
            selectedAnswer: undefined,
            chartConfig: {
                title: {
                    text: props.fullCountryReport == true ? '' : "<h2 class='title--card'>"+title+"</h2>",
                    align: 'left',
                    widthAdjust: -50,
                    style: {
                        zIndex: 1,
                        lineHeight:36
                    }
                },
                credits: {
                    enabled: true,
					text: "",
					href: '',
					style: {
						cursor: 'arrow'
					},
					position: {
						x: this.props.selectedIndicator == 'ewcs' ? -270 : -130
					}
                },
                colors: this.props.colors,
                chart: {
                    height: window.innerWidth > 768 ? this.props.fullCountryReport == true ? 250 : 450 : 770,
                    type: this.props.type,
                    backgroundColor: '#F0F0F0',
                    events: {
                        render: function() {
                            let chart = this;
                            stateThis.showEurofoundImage(chart);
                        }					
                    },
                },
				exporting: {
					enabled: props.fullCountryReport == true ? false : true,
                    sourceHeight: 600,
					buttons: {
						contextButton: {
							menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]							
						}
					},
                    sourceWidth: largeSize,
                    filename: title.replace(/ /g, '_'),
                    menuItemDefinitions: {
                        "downloadXLS": {
                            onclick: function() {
                                xlsxCustomExport('Trend', this.series, this.title.textStr);
                            }
                        }
                    }
				},
				navigation: {
					buttonOptions: {
						theme: {
							fill: 'transparent',
							states: {
								hover: {
									fill: '#CCC'
								},
								select: {
									fill: 'transparent'
								}
							}
						}
					}
				},
                legend:{
                    verticalAlign: 'bottom',
                    symbolRadius: 0,
                    itemMarginTop:4,
                    itemMarginBottom:4,
                    itemStyle: {
                        fontFamily: 'OpenSans',
                        fontWeight: 'normal',
                        fontSize:'12px',
                        textOverflow: "ellipsis",
                        width: 250
                    }
                },
                yAxis: {
                    gridLineColor: '#FFF',
                    gridLineWidth: 2,
                    startOnTick: true,
                    endOnTick: true,
                    tickInterval: this.props.step ? this.props.step : null,
                    max: this.props.yAxisMax ? this.props.yAxisMax : null,
                    title: {
                        text: ''
                    },
                    labels: {
                        format: this.props.percentage === true ? '{value}%' : `{value}`,
                        style: {
                            fontFamily: 'OpenSans-bold',
                            fontWeight: 'normal',
                            fontSize:  this.props.fullCountryReport ? '10px' : '12px',
                            textOverflow: 'none'
                        }
                    }
                },
                xAxis: {
                    lineWidth: 0,
                    labels: {	
                        style: {
                            fontFamily: 'OpenSans-bold',
                            fontWeight: 'normal',
                            fontSize: this.props.fullCountryReport ? '10px' : '12px' ,
                            textOverflow: 'none'
                        }
                    }
                },
				tooltip: {},
                plotOptions: {},
                series: []
            },
            isLoading: true
        }
    }

    showEurofoundImage = (chart) => {
        let showEurofound = this.props.selectedIndicator != undefined ? this.props.selectedIndicator : this.state.selectedTypeChart ;
        if (!chart.customImage)
        {
            chart.customImage = chart.renderer.image(
                `${IMG_URL}osh-barometer/img/EU-OSHA-en.png`,
                chart.chartWidth - 130,
                chart.chartHeight - 37,
                130,
                37
            ).add();
            chart.customImage.attr({
            class:'osha-logo'
        });
        }
        else
        {
            chart.customImage.attr({
                x: chart.chartWidth - 130,
                y: chart.chartHeight - 37
            });
        }
        
        if(showEurofound == 'ewcs'){
            if (!chart.customImageEurofound)
            {
                chart.customImageEurofound = chart.renderer.image(
                    `${IMG_URL}osh-barometer/img/eurofound-logo.png`,
                    chart.chartWidth - 270,
                    chart.chartHeight - 37,
                    130,
                    37
                ).add();
                chart.customImageEurofound.attr({
                class:'eurofound-logo'
            });
            }
            else
            {
                chart.customImageEurofound.attr({
                    x: chart.chartWidth - 270,
                    y: chart.chartHeight - 37
                });
            }
        }

        if (chart.fullscreen.isOpen) {
            chart.customImage.css({
                display: 'block'
            });
            if(showEurofound == 'ewcs'){
                chart.customImageEurofound.css({
                    display: 'block'
                });
            }
            chart.container.className = 'highcharts-container full-screen';
        }
        else
        {
            chart.customImage.css({
                display: ''
            });
            if(showEurofound == 'ewcs'){
                chart.customImageEurofound.css({
                    display: ''
                });
            }
            chart.container.className = 'highcharts-container';
        }
    }

    // Gets data for the selected Chart
    getLoadData = (chartType) => {
        let categories = [];
        let series = [];
        let chart = [];

        if (chartType.length > 1) {
            chart = chartType.find((chart) => chart.type == this.state.selectedTypeChart);
            this.setState({ selectedChart: chart });
        } else {
            chart = chartType[0];
            this.setState({ selectedTypeChart: null });
        }

        // Load the texts for the credits in the image when maximising or exporting the chart
        this.getCredits(chart.chart);

        if(this.props.callbackLegend != undefined){
            this.props.callbackLegend(chart.legend);
        }

        let requestFilter = {
            chart: chart.chart,
            indicator: chart.chartIndicator,
            answer: this.props.selectedAnswer,
            datasetIndicator1: this.props.selectedDataset1,
            datasetIndicator2: this.props.selectedDataset2,
            sector: chart.sector
        }
        getNewChartData(requestFilter)
        .then((data) => {
            if(data.resultset){
                categories = data.resultset.xAxisCategories;

                try {
                    this.setState({ ...this.state, isLoading: true });
                    
                    data.resultset.data.forEach(element => {
                        series.push({name: element.name, data: element.data});
                    });
                    
                } catch (error) {
                    console.log('error fetching data', error)
                } finally {
                    this.setState({ ...this.state, isLoading: false })
                }
    
                this.setState({
                    chartConfig: {...this.state.chartConfig, 
                        xAxis: {
                            categories,
                            plotLines: [
                                {
                                    color: 'black',
                                    width: 2,
                                    value: 0.5,
                                    id: 'break-eu',
                                    zIndex:1
                                },
                                {
                                    color: 'black',
                                    width: 2,
                                    value: 27.5,
                                    id: 'break-country',
                                    zIndex:1
                                }
                            ],
                        },
                        tooltip: {					
                            useHTML: true,
                            borderColor:"#529FA2",
                            style: {
                                opacity: 1,
                                zIndex: 100
                            },
                            formatter: function () {
                                return '<ul class="tooltip-item">'+
                                '<li><strong>Trend: </strong> ' + this.series.name + '</li>' +
                                '<li><strong>Country: </strong> '+ this.point.category + '</li>' +
                                '<li><strong class="tooltip-value up">Value: </strong>' + Math.round(this.point.y * 10) / 10 +'</li>' +
                                '</ul>';
                            }
                        },
                        plotOptions: {
                            series: {
                                pointPadding: 0.11,
                                groupPadding: 0.15,
                                borderWidth: 0,
                                pointStart: 0
                            },
                        }, 
                        series
                    }
                })
            }
        })
    }

    getCredits = (chart) => {
        getDatasourceAndDates(chart).then((res)=>{
            let text = res;
            this.setState({
                chartConfig: {...this.state.chartConfig, credits: {...this.state.chartConfig.credits, text}}
            })
        })		
    }

    updateDimension = () => {
        const width = window.innerWidth;
        const height = window.innerHeight;

        let chartTitleLiteral = '';

        if (this.props.chartType.length > 1) {
            chartTitleLiteral = this.props.chartType.find((chart) => chart.type == this.state.selectedTypeChart).title;
        }else{
            chartTitleLiteral = this.props.chartType[0].title;
        }

        if (width > 767) {
            const title = this.props.literals[`L${chartTitleLiteral}`];
            if (isFullscreen()) {
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height: height},
                    }
                });
            } else {
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height: this.props.fullCountryReport == true? 250 : 450, type: 'column'},
                        title: {...this.state.chartConfig.title, text: this.props.fullCountryReport == true ? '' : this.props.reportTitle != undefined ? "<h2 class='title--card'>"+this.props.reportTitle+"</h2>" : `<h2 class='title--card'>${title}</h2>`}
                        // title: {...this.state.chartConfig.title, text: `<h2 class='title--card'>${title}</h2>`}
                    }
                });
            }
        }

        let tabTitle = this.props.literals[`L${this.props.tabIndicator}`];

        if (width < 768) {
            
            if (isFullscreen()) {
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height: height},
                    }
                });
            } else {
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height: 785, type: 'bar'},
                        // title: {...this.state.chartConfig.title, text: this.props.reportTitle != undefined ? "<h2 class='title--card'>"+this.props.reportTitle+"</h2>" : <h2 class='title--card'>${tabTitle}</h2>}
                        title: {...this.state.chartConfig.title, text: this.props.fullCountryReport == true ? '' : `<h2 class='title--card'>${tabTitle}</h2>`}
                    }
                });
            }
        }

        if (width < 400) {
            this.setState({
                chartConfig: {
                    ...this.state.chartConfig,
                    chart: {...this.state.chartConfig.chart, height: 1300},
                    title: {...this.state.chartConfig.title, text: this.props.fullCountryReport == true ? '' : `<h2 class='title--card'>${tabTitle}</h2>`}
                }
            });
        }        
	}

    componentDidMount() {
        this.getLoadData(this.props.chartType);
        window.addEventListener('resize', this.updateDimension);
        this.updateDimension();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.chartType != this.props.chartType)
        {
            this.getLoadData(this.props.chartType);
            this.updateDimension();
        }

        if(prevProps.selectedDataset1 != this.props.selectedDataset1 || prevProps.selectedDataset2 != this.props.selectedDataset2
            || prevProps.selectedAnswer != this.props.selectedAnswer){
            this.getLoadData(this.props.chartType);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimension);
    }

    render(){

        return(           
            <div className='chart-container'>
                {!this.state.isLoading && (
               <HighchartsReact
                    highcharts={Highcharts}
                    options={this.state.chartConfig}
                    containerProps={{ className: 'chartContainer' }}
                />)}
            </div>
        )
    }
}

export default TrendDiagram;